import translate from "../functions/translate";
import { InternalLink } from "./InternalLink";

export const textStartInstructions = <ol className="ds-u-margin--0">
    <li className="ds-u-margin-bottom--1">{translate('text_start')}</li>
    <li>{translate('select_button_text_below', { buttonText: translate('send_my_code_sms') })}</li>
</ol>;

export const reviewTermsAndConditionsAndPrivacyPolicy = (heading: string) => <>
    {translate("review_our")} {' '}
    <a target="_blank" rel="noreferrer" href={translate("wireless_terms_url")}>{translate("wireless_terms_and_conditions")}</a>
    {` ${translate('and')} `}
    <InternalLink analyticsParentHeading={heading} href={translate("privacy_policy_url")} siteSection={'mfa'}>{translate("privacy_policy_information")}</InternalLink>
    {' '}{translate("for_more_information")}
</>;